import { render, staticRenderFns } from "./LegalFaceFormModal.vue?vue&type=template&id=40a286f6&scoped=true&"
import script from "./LegalFaceFormModal.vue?vue&type=script&lang=js&"
export * from "./LegalFaceFormModal.vue?vue&type=script&lang=js&"
import style0 from "./LegalFaceFormModal.vue?vue&type=style&index=0&id=40a286f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a286f6",
  null
  
)

export default component.exports